import { useAuth } from '@/contexts/AuthContext';
import { useReminderTriggers } from '@/hooks/useReminderTriggers';

/**
 * Provider component that listens for ticket changes and triggers reminder actions.
 * Should be mounted once at the app level for each shop.
 */
export const ReminderTriggerProvider = ({ children }: { children: React.ReactNode }) => {
  const { activeShop } = useAuth();
  
  // This hook sets up realtime listeners and handles reminder triggers
  useReminderTriggers(activeShop?.id || null);
  
  return <>{children}</>;
};
